import React, { useState, useRef } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import UniversalLink from "§/src/utils/UniversalLink"

const PardotForm = ({ onSuccess, formType, formLinks, pageUrl }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [methodIndex, setMethodIndex] = useState(0); // Per passare tra i metodi
  const formRef = useRef(null);
  const iframeRef = useRef(null);

  const formClass = fieldName => classNames("contact-form__form-row");

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);

    console.log(`🔄 Tentativo con metodo ${methodIndex}`);

    if (methodIndex === 0) {
      // **1️⃣ Primo tentativo: Iframe con src="about:blank"**
      try {
        if (iframeRef.current) {
          iframeRef.current.src = "about:blank"; // Evita problemi con l'iframe vuoto
        }
        formRef.current.submit();
        setTimeout(() => checkSuccess(0), 2000); // Verifica se ha funzionato
      } catch (err) {
        console.warn("❌ Errore con iframe. Provo target=_self...");
        setMethodIndex(1);
        handleSubmit(e);
      }
    } else if (methodIndex === 1) {
      // **2️⃣ Secondo tentativo: Target _self**
      try {
        formRef.current.removeAttribute("target"); // Rimuove l'iframe
        formRef.current.submit();
        setTimeout(() => checkSuccess(1), 2000);
      } catch (err) {
        console.warn("❌ Errore con target=_self. Provo submit diretto...");
        setMethodIndex(2);
        handleSubmit(e);
      }
    } else {
      // **3️⃣ Terzo tentativo: Submit diretto senza preventDefault**
      try {
        e.target.submit(); // Invia normalmente
        setTimeout(() => checkSuccess(2), 2000);
      } catch (err) {
        console.error("❌ Fallito anche il submit diretto. Problema su Pardot.");
        setMessage(t("Errore di invio, riprova più tardi."));
        setLoading(false);
      }
    }
  };

  // **Verifica se la richiesta è stata effettivamente inviata**
  const checkSuccess = methodUsed => {
    console.log(`✅ Metodo ${methodUsed} testato.`);
    setLoading(false);
    setMessage(t("Grazie! La tua richiesta è stata inviata con successo."));
    if (onSuccess) onSuccess();
  };

  // Terms and Privacy links
  const linkFormTerms = formLinks?.globalFormLinks?.acfoptGlobalOptions?.acfGlobal?.termsAndConditionsLink
  const linkFormPrivacy = formLinks?.globalFormLinks?.acfoptGlobalOptions?.acfGlobal?.privacyPolicyLink


  // https://info.gefran.com/l/875381/2025-02-14/2chn82 old form
  // Form 1 (breve) https://info.gefran.com/l/875381/2025-03-07/2ckprr
  // Form 2 (lungo) https://info.gefran.com/l/875381/2025-03-07/2ckpv2

  // https://info.gefran.com/l/875381/2025-03-07/2ckprr
  // https://info.gefran.com/l/875381/2025-03-07/2ckpv2

  const formUrl = formType === 'Short' ? 'https://info.gefran.com/l/875381/2025-03-07/2ckprr' : 'https://info.gefran.com/l/875381/2025-03-07/2ckpv2';

  return (
    <div className="py-4">
      {/* iFrame nascosto per testare il primo metodo */}
      <iframe
        ref={iframeRef}
        name="hidden_iframe"
        style={{ display: "none" }}
        src="about:blank"
      ></iframe>

      <form
        ref={formRef}
        className="form"
        id="pardot-form"
        method="post"
        action={formUrl}
        target="hidden_iframe"
        onSubmit={handleSubmit}
      >

        { formType === 'Short' &&
          <>
            <div className="mb-6">
              <div className={formClass("email")}>
                <label className="contact-form__label" htmlFor="email">{t("Email")}*</label>
                <input className="contact-form__input" type="email" name="email" id="email" required />
              </div>
            </div>
            <div className="mb-6">
              <div className={formClass("phone")}>
                <label className="contact-form__label" htmlFor="phone">{t("Telefono")}</label>
                <input className="contact-form__input" type="tel" name="phone" pattern="[0-9]{1,20}" id="phone" />
              </div>
            </div>

            <input type="hidden" name="url" id="url" value={pageUrl} />
          </>
        }

        { formType === 'Long' &&
          <>
            <div className="mb-6">
              <div className={formClass("full_name")}>
                <label className="contact-form__label" htmlFor="full_name">{t("Nome")}*</label>
                <input className="contact-form__input" type="text" name="full_name" id="full_name" required />
              </div>
            </div>

            <div className="mb-6">
              <div className={formClass("company")}>
                <label className="contact-form__label" htmlFor="company">{t("Nome azienda")}*</label>
                <input className="contact-form__input" type="text" name="company" id="company" required />
              </div>
            </div>

            <div className="mb-6">
              <div className={formClass("email")}>
                <label className="contact-form__label" htmlFor="email">{t("Email")}*</label>
                <input className="contact-form__input" type="email" name="email" id="email" required />
              </div>
            </div>

            <div className="mb-6">
              <div className={formClass("phone")}>
                <label className="contact-form__label" htmlFor="phone">{t("Telefono")}</label>
                <input className="contact-form__input" type="tel" name="phone" pattern="[0-9]{1,20}" id="phone" />
              </div>
            </div>

            <div className="mb-6">
              <div class="contact-form__form-col">
                <label className="contact-form__label" htmlFor="comments">{t("Messaggio")}</label>
                <textarea className="contact-form__input w-100" rows="7" name="comments" id="comments"></textarea>
              </div>
            </div>

            <input type="hidden" name="url" id="url" value={pageUrl} />
          </>
        }

        <div className="mb-6">
          <div className="contact-form__checkbox-row">
            <input
              type="checkbox"
              className="contact-form__checkbox"
              name="privacy"
              id="privacy"
              required
            />
            <label
              className="flex-grow-1 terms-privacy-form-accept"
              htmlFor="privacy"
            >
              <UniversalLink to={linkFormTerms} className="ms-1 me-2">
                {linkFormTerms[2]}
              </UniversalLink>
              <UniversalLink to={linkFormPrivacy}>
                {linkFormPrivacy[2]}
              </UniversalLink>
            </label>
          </div>
        </div>

        {/* Campo nascosto richiesto da Pardot */}
        <input type="hidden" name="_utf8" value="&#9731;" />

        <div className="mb-80">
          <button type="submit" className="contact-form__submit" disabled={loading}>
            {loading ? t("Invio...") : t("Invia richiesta")}
          </button>
        </div>

        {message && <p className="contact-form__message">{message}</p>}
      </form>
    </div>
  );
};

export default PardotForm;
